import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CadastroService } from '../../../../../services/cadastro.service';
import { Produto, Ncm } from '../../../../../models/cadastro.model';
import { ModalStateService } from '../../../../../services/modaState.service';
import { CommonModule } from '@angular/common';
import { ErrorModel } from '../../../../../models/error.model';
import { NcmModal } from '../../../../modal/ncm-modal/ncm-modal';
import { take } from 'rxjs';
import { ParametrosService } from '../../../../../services/parametros.service';
import { Parametros } from '../../../../../models/parametros.model';

@Component({
  selector: 'app-produtos-manutencao',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NcmModal],
  templateUrl: './produtos-manutencao.component.html',
  styleUrls: ['./produtos-manutencao.component.css']
})
export class ProdutosManutencaoComponent implements OnInit {
  produtoForm!: FormGroup;
  produtoId: number | null = null;
  isEditMode = false;
  isNcmModalOpen = false;
  protected isReadOnly: boolean = true;
  categoriasProduto: Parametros[] = [];
  classesProduto: Parametros[] = [];
  readonly unidadesMedida: readonly string[] = ['UN', 'KG', 'G', 'L', 'ML', 'M', 'M2', 'M3', 'PC', 'CX'];
  private modalStateService = inject(ModalStateService);
  private parametrosService = inject(ParametrosService);

  constructor(
    private fb: FormBuilder,
    private cadastroService: CadastroService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.parametrosService.getParametrosByCategorias(['CATEGORIA_PRODUTO']).subscribe({
      next: (data) => this.categoriasProduto = data,
      error: () => this.toastr.error('Erro ao carregar categorias de produto.')
    });

    this.parametrosService.getParametrosByCategorias(['CLASSE_PRODUTO']).subscribe({
      next: (data) => this.classesProduto = data,
      error: () => this.toastr.error('Erro ao carregar classes de produto.')
    });

    this.produtoForm = this.fb.group({
      nomeProduto: ['', Validators.required],
      descricao: [''],
      tipo: [''],
      classe: [''],
      dimensaoUnitariaM2: [0],
      codigoBarra: [''],
      status: [0],
      sku: [''],
      unMedida: [''],
      ncm: this.fb.group({
        id: [0],
        codigo: [''],
        descricao: ['']
      })
    });

    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.isEditMode = true;
        this.produtoId = +id;
        this.loadProduto(this.produtoId);
      }
    });
  }

  loadProduto(id: number): void {
    this.cadastroService.getProdutoById(id).subscribe(produto => {
      this.produtoForm.patchValue(produto);
    });
  }

  salvarProduto(): void {
    if (this.produtoForm.valid) {
      const produtoData: Produto = { id: this.produtoId || 0, ...this.produtoForm.value };
   

      const operation = this.isEditMode
        ? this.cadastroService.updateProduto(produtoData, this.produtoId!)
        : this.cadastroService.createProduto(produtoData);

      operation.subscribe({
        next: () => {
          this.toastr.success(`Produto ${this.isEditMode ? 'atualizado' : 'cadastrado'} com sucesso!`);
          this.router.navigate(['/home', 'produto-cadastro']);
        },
        error: (error) => {
          const erro: ErrorModel = error.error;
          this.toastr.error(erro.message);
        }
      });
    } else {
      this.toastr.error('Por favor, preencha todos os campos obrigatórios.');
    }
  }

  pesquisarNcm(): void {
   this.isNcmModalOpen = !this.isNcmModalOpen;
   this.modalStateService.modalResult$
      .pipe(take(1))
      .subscribe((ncm: Ncm) => {
        if (ncm) {
        this.produtoForm.patchValue({
          ncm: {
            id: ncm.id,
            codigo: ncm.codigo,
            descricao: ncm.descricao,

          }
        });
      } else {
        this.isNcmModalOpen = false;
      }
      });

  }


  cancelar(): void {
    this.router.navigate(['/home', 'produto-cadastro']);
  }



}
